import React, { useRef } from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
	ChartData,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import Loading from '../Loading';
// @ts-ignore
import styles from './LineChart.module.scss';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
);

const DEFAULT_OPTIONS = {
	scales: {
		y: {
			beginAtZero: true,
			ticks: {
				fontSize: 18,
			},
		},
	},
	responsive: true,
	plugins: {
		legend: {
			position: 'top',
		},
	},
	maintainAspectRatio: false,
};

interface LineChartProps {
	data: any;
	isLoading?: boolean;
	options?: any;
	scrollbar?: boolean;
	onScroll?: (event: any) => void;
	scrollbarWidth?: number;
}

const LineChart: React.FC<LineChartProps> = props => {
	const { data, options, isLoading, scrollbar, onScroll, scrollbarWidth } =
		props;

	return (
		<div style={{ height: '300px', position: 'relative' }}>
			{isLoading && <Loading absolute />}
			<Line options={options ?? DEFAULT_OPTIONS} data={data} />
			{scrollbar && !!onScroll && !!scrollbarWidth && (
				<div className={styles.scrollbarWrapper} onScroll={onScroll}>
					<div style={{ width: `${scrollbarWidth}px`, height: '20px' }} />
				</div>
			)}
		</div>
	);
};

export default LineChart;
